import React from "react";
import {usePage} from "@inertiajs/react";
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import HtmlEditor from "../HtmlEditor.jsx";

/**
 * Schritt 2 des Kampagnen-Assistenten: der eigentliche Mail-Inhalt -
 * Text, Signatur (mit Vorschau) und Anhang. "Test-Mail an mich" ist erst
 * möglich, wenn die Kampagne schon einmal gespeichert wurde (braucht eine ID).
 */
export default function StepInhalt({
    data,
    setData,
    errors,
    signatures,
    placeholders,
    maxAttachmentMb,
    campaign,
    attachmentTooBig,
    handleFileChange,
    testMailSending,
    handleTestMail,
}) {
    const selectedSignature = (signatures ?? []).find(
        (s) => String(s.id) === String(data.campaign_signature_id)
    );

    const {auth} = usePage().props;
    const currentUserEmail = auth?.email ?? null;

    return (
        <Card>
            <Card.Body>
                <p className="text-muted">
                    Das ist der eigentliche Inhalt der Mail: Text, optional eine
                    Signatur darunter und ein Anhang. Über die Platzhalter-Chips im
                    Editor kannst du Anrede, Schulname usw. automatisch einsetzen
                    lassen.
                </p>

                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={2}>Inhalt</Form.Label>
                    <Col sm={10}>
                        <HtmlEditor value={data.body_html} onChange={(html) => setData("body_html", html)}
                                    placeholders={placeholders}/>
                        {errors.body_html && <div className="text-danger mt-1">{errors.body_html}</div>}
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={2}>Signatur</Form.Label>
                    <Col sm={10}>
                        <Form.Select id="campaign_signature_id" value={data.campaign_signature_id ?? ""}
                                     onChange={(e) => setData("campaign_signature_id", e.target.value)}>
                            <option value="">- keine -</option>
                            {(signatures ?? []).map((signature) => (
                                <option key={signature.id} value={signature.id}>{signature.name}</option>
                            ))}
                        </Form.Select>
                        {selectedSignature?.html && (
                            <div className="border rounded p-3 mt-2 bg-light">
                                <div className="text-muted small mb-1">Vorschau:</div>
                                <div dangerouslySetInnerHTML={{__html: selectedSignature.html}}/>
                            </div>
                        )}
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={2}>Anhang</Form.Label>
                    <Col sm={10}>
                        {campaign?.attachment_original_name && !data.attachment && (
                            <div className="mb-2">
                                Aktuell hinterlegt: {campaign.attachment_original_name}
                            </div>
                        )}
                        <Form.Control type="file" onChange={handleFileChange}
                                      className={errors.attachment || attachmentTooBig ? "is-invalid" : ""}/>
                        <Form.Text className={attachmentTooBig ? "text-danger" : "text-muted"}>
                            Maximale Anhang-Größe: {maxAttachmentMb} MB.
                        </Form.Text>
                        {errors.attachment && <div className="invalid-feedback d-block">{errors.attachment}</div>}
                        {attachmentTooBig && (
                            <div className="text-danger">Diese Datei überschreitet die maximale Größe von {maxAttachmentMb} MB.</div>
                        )}
                    </Col>
                </Form.Group>

                <Form.Group as={Row}>
                    <Form.Label column sm={2}>Test-Versand</Form.Label>
                    <Col sm={10}>
                        {campaign ? (
                            <>
                                <Button variant="outline-secondary" type="button" disabled={testMailSending}
                                        onClick={handleTestMail}>
                                    Test-Mail an mich senden
                                </Button>
                                <Form.Text className="d-block text-muted mt-1">
                                    Schickt genau diese Mail (mit Platzhalter-Beispielwerten) an dein eigenes Postfach -
                                    ohne Empfänger oder Zähler zu beeinflussen.
                                    {currentUserEmail && (
                                        <> Geht an: <strong>{currentUserEmail}</strong></>
                                    )}
                                </Form.Text>
                            </>
                        ) : (
                            <div className="text-muted">
                                Erst nach dem ersten Speichern („Weiter") möglich.
                            </div>
                        )}
                    </Col>
                </Form.Group>
            </Card.Body>
        </Card>
    );
}
